import React, { useState } from "react";
import { FilterDropdown } from "./FilterDropdown";
import { ENGAGEMENT_RANGES } from "./constants";

interface Props {
  selectedEngagementRanges: string[];
  onRangeSelect: (value: string) => void;
  onClearEngagement: () => void;
}

export function EngagementFilter({
  selectedEngagementRanges,
  onRangeSelect,
  onClearEngagement,
}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <FilterDropdown
      label="Engagement"
      count={selectedEngagementRanges.length}
      open={open}
      setOpen={setOpen}
      width="w-[260px]"
    >
      {ENGAGEMENT_RANGES.map((range) => {
        const isSelected = selectedEngagementRanges.includes(range.value);
        return (
          <button
            key={range.value}
            type="button"
            onClick={() => onRangeSelect(range.value)}
            className="w-full text-left px-4 py-3 rounded-[14px] font-raleway text-[16px] hover:bg-[#F3F4F6] font-medium"
          >
            <div className="flex items-start gap-3">
              <div className="mt-1 w-4 h-4 rounded-[4px] border-2 border-[#9CA3AF] flex items-center justify-center">
                {isSelected && <div className="w-2 h-2 rounded-[4px] bg-[#9333EA]" />}
              </div>
              <span className="text-[16px] leading-none">{range.label}</span>
            </div>
          </button>
        );
      })}

      <button
        type="button"
        onClick={onClearEngagement}
        className="w-full text-left px-4 py-3 rounded-[14px] font-raleway text-[16px] hover:bg-[#F3F4F6]"
      >
        <div className="flex items-center gap-3">
          <div className="w-4 h-4 rounded-[4px] border-2 border-[#9CA3AF] flex items-center justify-center">
            {selectedEngagementRanges.length === 0 && (
              <div className="w-2 h-2 rounded-[4px] bg-[#9333EA]" />
            )}
          </div>
          <span className="text-[16px] font-medium text-[#111827]">All</span>
        </div>
      </button>
    </FilterDropdown>
  );
}
